import { render, staticRenderFns } from "./subjectsListItem.vue?vue&type=template&id=1b453dff"
import script from "./subjectsListItem.vue?vue&type=script&lang=ts"
export * from "./subjectsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports